// Einstellungen → Benachrichtigungen: Web-Push für neue wichtige Mails (pro Gerät), Testnachricht.
import { useEffect, useState } from 'react';
import { api } from '../lib/api.ts';
import { pushAn, pushAus, pushMoeglich, pushStatus } from '../lib/push.ts';
import { toast } from './Toast.tsx';

export function PushSettings() {
  const [st, setSt] = useState<Awaited<ReturnType<typeof pushStatus>> | null>(null);
  const [busy, setBusy] = useState(false);
  const refresh = () => void pushStatus().then(setSt);
  useEffect(() => refresh(), []);
  const toggle = async () => {
    setBusy(true);
    try {
      if (st?.aktiv) {
        await pushAus();
        toast('Push auf diesem Gerät aus');
      } else {
        await pushAn();
        toast('Push auf diesem Gerät an');
      }
      refresh();
    } catch (e) {
      toast((e as Error).message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="s-snip">
      <div>
        Push-Benachrichtigung bei jeder neuen wichtigen Mail in deinen Postfächern (Info und Junk
        melden sich nicht). Gilt je Gerät – am Handy nach „Zum Home-Bildschirm“ einschalten.
      </div>
      {!pushMoeglich() && (
        <div className="muted" style={{ fontSize: 12 }}>
          Dieser Browser unterstützt keine Push-Benachrichtigungen.
        </div>
      )}
      {st && !st.verfuegbar && pushMoeglich() && (
        <div className="muted" style={{ fontSize: 12 }}>
          Auf dem Server noch nicht eingerichtet (VAPID-Schlüssel fehlen).
        </div>
      )}
      {st?.verfuegbar && (
        <div
          style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 6, flexWrap: 'wrap' }}
        >
          <button
            className={`btn sm ${st.aktiv ? '' : 'pri'}`}
            disabled={busy}
            onClick={() => void toggle()}
          >
            {st.aktiv ? 'Push auf diesem Gerät ausschalten' : 'Push auf diesem Gerät einschalten'}
          </button>
          {st.aktiv && (
            <button
              className="btn sm"
              onClick={() =>
                void api
                  .pushTest()
                  .then((r) => toast(r.gesendet ? 'Testnachricht geschickt' : 'Kein Abo gefunden'))
              }
            >
              Test senden
            </button>
          )}
          {st.erlaubnis === 'denied' && (
            <span className="muted" style={{ fontSize: 12 }}>
              Benachrichtigungen sind im Browser blockiert – in den Seiteneinstellungen erlauben.
            </span>
          )}
        </div>
      )}
      <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>
        Tagesstart „Heute zuerst“: Sortierung „Wichtig zuerst“ in der Liste (Termin in 14 Tagen,
        ALL-IN-Fenster, offenes Angebot, Beschwerde).
      </div>
    </div>
  );
}
